"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
function getReadStaticActions() {
    var actions = [
        'Reply',
        'ReplyAll',
        'Forward',
        '-',
        'Delete',
        '-',
        'MarkReadUnread',
        'FlagUnflag',
        '-',
    ];
    if (!getUserConfiguration_1.default().SessionSettings.IsShadowMailbox) {
        actions.push('MarkJunkNotJunk', 'MarkAsPhishing', 'Block', '-');
    }
    actions.push('CreateRule', 'Print');
    if (owa_mail_feature_flags_1.isMailFeatureEnabled('rp-immersiveReader')) {
        actions.push('ShowInImmersiveReader');
    }
    return actions;
}
exports.getReadStaticActions = getReadStaticActions;
function getComposeStaticActions() {
    return [
        'AddAttachment',
        'AddInlineImage',
        'AddEmoji',
        'ToggleRibbon',
        'SaveDraft',
        'InsertSignature',
        'ShowFrom',
        'SetImportance',
    ];
}
exports.getComposeStaticActions = getComposeStaticActions;
function shouldAddActionToEnd(action) {
    // Reply, ReplyAll, and Forward are the first 3 actions in the set of static actions in the reading pane.
    // While all other actions should render from right to left based on their order in the settings,
    // the desire is for these three to render left to right, so they should be inserted at the end of the collection.
    return action == 'Reply' || action == 'ReplyAll' || action == 'Forward';
}
exports.shouldAddActionToEnd = shouldAddActionToEnd;
//# sourceMappingURL=getStaticActions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-surface-actions/lib/utils/getStaticActions.js
// module id = 3091
// module chunks = 2 3 4